import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import axios from "axios";
import {
  Response,
  statesListResponse,
  CityListResponse,
  walletTypeListResponse,
  settingResponse,
  getBranchListResponse,
  FileUploadResponse,
  getBankAccountResponse,
} from "../../types/global";

import {
  getState as getStateUrl,
  getCity as getCityUrl,
  getWalletTypeList as getWalletTypeListUrl,
  encryptPassword as encryptPasswordUrl,
  getBankList as getBankListUrl,
  getSettingList as getSettingListUrl,
  getBranchList as getBranchListUrl,
  fileUpload as fileUploadUrl,
  getBankAccount as getBankAccountUrl,
} from "../../helpers/apiUrl";
import { axiosClient, axiosClientUpload } from "../../helpers/apiClient";
import * as types from "../../types/annoucement";

export const getStatesList = createAsyncThunk(
  "parameter/get-state-by-countryid?countryId=1",
  async () => {
    return axiosClient
      .get(getStateUrl)
      .then((d: AxiosResponse<Response<statesListResponse[]>>) => d.data)
      .then((d: Response<statesListResponse[]>) => d.data);
  },
);

export const getCityList = createAsyncThunk(
  "parameter/get-city",
  async (stateId: number) => {
    return axiosClient
      .get(`${getCityUrl}?stateId=${stateId}`)
      .then((d: AxiosResponse<Response<CityListResponse[]>>) => d.data)
      .then((d: Response<CityListResponse[]>) => d.data);
  },
);

export const getWalletTypeList = createAsyncThunk(
  "parameter/get-wallet-type",
  async () => {
    return axiosClient
      .get(getWalletTypeListUrl)
      .then((d: AxiosResponse<Response<walletTypeListResponse[]>>) => d.data)
      .then((d: Response<walletTypeListResponse[]>) => d.data);
  },
);

export const encryptPassword = createAsyncThunk(
  "parameter/encrypt",
  async (phase: string) => {
    const urlWithPassword = `${encryptPasswordUrl}/?phase=${phase}`;
    return axios
      .get(urlWithPassword)
      .then((d: AxiosResponse) => d.data)
      .then((d: AxiosResponse) => d.data);
  },
);

export const getBankList = createAsyncThunk(
  "parameter/get-banks-by-countryid",
  async () => {
    return axiosClient
      .get(getBankListUrl)
      .then((d: AxiosResponse) => d.data)
      .then((d: AxiosResponse) => d.data);
  },
);

export const getSettingList = createAsyncThunk(
  "setting/get-setting-company-fees",
  async () => {
    return axiosClient
      .get(getSettingListUrl)
      .then((d: AxiosResponse<Response<settingResponse>>) => d.data)
      .then((d: Response<settingResponse>) => d.data);
  },
);

export const getBranchList = createAsyncThunk(
  "inventory/get-pickup-branch",
  async () => {
    return axiosClient
      .get(getBranchListUrl)
      .then((d: AxiosResponse<Response<getBranchListResponse[]>>) => d.data)
      .then((d: Response<getBranchListResponse[]>) => d.data);
  },
);

export const uploadFile = createAsyncThunk(
  "fileUpload/upload-image",
  async (payload: File) => {
    const pyform = new FormData();
    pyform.append("files", payload);

    return axiosClientUpload
      .post(fileUploadUrl, pyform)
      .then((d: AxiosResponse<Response<FileUploadResponse[]>>) => d.data)
      .then((d: Response<FileUploadResponse[]>) => d.data);
  },
);

export const getBankAccount = createAsyncThunk(
  "setting/get-setting-company-bank",
  async () => {
    return axiosClient
      .get(getBankAccountUrl)
      .then((d: AxiosResponse<Response<getBankAccountResponse>>) => d.data)
      .then((d: Response<getBankAccountResponse>) => d.data);
  },
);
